import { Injectable } from '@angular/core';
import { AppStore } from '@app/app.store';
import { DataTableState, EmptyDataTableState } from './state.model';
import { StateService } from './state.service';

@Injectable()
export class StateServiceImpl implements StateService {
  constructor(private appStore: AppStore) {}

  init(id: string): DataTableState {
    const states: { [key: string]: DataTableState } = this.appStore.state.dataTableState;
    if (!states[id]) {
      states[id] = new EmptyDataTableState(id);
      this.appStore.saveState();
    }

    return states[id];
  }

  get(id: string): DataTableState {
    const state: DataTableState = this.appStore.state.dataTableState[id];
    if (!state) {
      return this.init(id);
    }

    return state;
  }

  clearAndGet(idPrefix: string, id: string): DataTableState {
    const matchingKey: string = Object.keys(this.appStore.state.dataTableState).find((key: string) =>
      key.startsWith(idPrefix)
    );

    if (matchingKey !== id) {
      this.delete(matchingKey);
    }

    return this.get(id);
  }

  exists(id: string): boolean {
    return !!this.appStore.state.dataTableState[id];
  }

  update(state: DataTableState): void {
    this.appStore.state.dataTableState[state.id] = state;
    this.appStore.saveState();
  }

  delete(id: string): void {
    delete this.appStore.state.dataTableState[id];
    this.appStore.saveState();
  }

  clear(): void {
    this.appStore.state.dataTableState = {};
    this.appStore.saveState();
  }

  clearAllSearch(): void {
    Object.keys(this.appStore.state.dataTableState).forEach(table => {
      this.appStore.state.dataTableState[table].filter.search = '';
    });
    this.appStore.saveState();
  }
}
